import { alertController, modalController, toastController, } from '@ionic/vue';

import moment from 'moment';

export function utils() {
  const formatDate = (date: any, dateFormat: any = 'D MMM YYYY') => moment(new Date(date)).format(dateFormat);
  const getProxyImgLink = (imgLink: any) => (imgLink && imgLink.startsWith("http") ? `https://cms.signals.hk/imgproxy.php?url=${encodeURIComponent(imgLink)}` : imgLink);

  return {
    formatDate,
    getProxyImgLink,
    openModal: async (component: any, componentProps: any) => {
      const modal = await modalController.create({
        component,
        componentProps,
      });
      return modal.present();
    },
    closeModal: async (data: any = {}) => {
      await modalController.dismiss(data);
    },
    focusInputField: (refEl: any) => {
      refEl.$el.setFocus();
    },
    numberWithCommas: (x: any) => {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    sleep: (s: any) => {
      return new Promise((resolve) => {
        setTimeout(resolve, s * 1000);
      });
    },
    presentAlert: async (msg: string, hideHeader = false, callback: any = null) => {
      const obj: any = {
        header: 'ERROR!',
        message: msg,
        buttons: callback == null ? ['OK'] : [
          {
            text: 'OK',
            handler: callback,
          }
        ]
      }
      if (hideHeader) delete obj.header;
      const alert = await alertController.create(obj);
      return await alert.present();
    },
    presentToast: async(msg: string, duration = 3000, position: any = 'bottom', buttons = []) => {
      const toast = await toastController.create({
        message: msg,
        duration,
        position,
        buttons,
      });
      toast.present();
    },
    presentPrompt: async (message: any = "", callback: any) => {
      const alert = await alertController.create({
        message,
        buttons: [
          {
            text: '取消',
            role: 'cancel',
            cssClass: 'secondary',
          },
          {
            text: '確認',
            handler: callback,
          }
        ]
      });
      return alert.present();
    },
  };
}